module.exports = __webpack_public_path__ + "img/pool-gold-icon.59ef0df9.png";